import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { PURCHASES_PATH } from "utils/constants/paths";

const Purchases = Loadable(React.lazy(() => import("./View")));
// const PurchasesDetail = Loadable(React.lazy(() => import("./Detail")));

export const PurchasesRoute: IRouteItem = {
  path: PURCHASES_PATH,
  iconName: "Bag2",
  element: React.createElement(Purchases),
  name: "Purchases",
  accessKeys: ["SuperAdmin", "Admin", "Analytics", "Support", "Manager"],
  children: [
    // {
    //   path: `${PURCHASES_DETAIL_PATH}/:id`,
    //   element: React.createElement(PurchasesDetail),
    //   showInDrawer: false,
    // },
  ],
};
